export const authorLevelInfoPanelTextureSrc = '/images/original-plus/author-level-info-texture.png';

export const authorLevelInfoPanelMobileTextureSrc =
  '/images/original-plus/author-level-panel-mobile-bg.png';

export const authorLevelPanelListItemClassName =
  'font-sans text-[13px] font-normal leading-[18px] tracking-normal text-[#F4F4F4]';

export const authorLevels = [
  {
    id: 'start',
    numeral: 'I',
    levelHeading: 'Уровень I',
    title: 'Старт',
    markerTagline: 'Вход',
    tagline: 'Вход в программу',
    numeralColor: 'text-[#181818]',
    circleSize: 96,
    circleClassName:
      'bg-[#B45CFF] shadow-[0_0_16px_6px_rgba(180,92,255,0.12),0_0_40px_14px_rgba(180,92,255,0.08),0_0_72px_24px_rgba(180,92,255,0.05),0_0_96px_32px_rgba(180,92,255,0.03)]',
    showStar: false,
    panelThemeColor: '#A84DFF',
    panelBadgeTextureSrc: '/images/original-plus/author-level-badge-1.png',
    panelBadgeGlow: '0 0 124px 0 #B45CFF99',
    panel: {
      description:
        'Для авторов, которые хотят пройти отбор, опубликовать произведение и получить статус участника Molwe Ориджинал Плюс',
      items: [
        'Кураторский отбор',
        'Публикация под брендом Molwe',
        'Дистрибуция',
        'Оформление карточки',
        'Базовая аналитика',
        'Рекомендации по доработке',
        'Авторское сообщество',
      ],
      price: 'БЕСПЛАТНО',
      priceCaption: '',
      ctaLabel: 'Начать',
      ctaTextColor: '#F4F4F4',
    },
  },
  {
    id: 'growth',
    numeral: 'II',
    title: 'Рост',
    markerTagline: 'Охваты',
    tagline: 'Первые охваты',
    numeralColor: 'text-[#505CFF]',
    circleSize: 96,
    circleClassName: 'border-2 border-[#4D7EFF] bg-[#1B1D22]',
    showStar: false,
    panelThemeColor: '#505CFF',
    levelHeading: 'Уровень II',
    panelBadgeTextureSrc: '/images/original-plus/author-level-badge-2.png',
    panelBadgeGlow: '0 0 124px 0 #4D7EFF99',
    panel: {
      description:
        'Для авторов, которым важно стать заметнее внутри Molwe, начать формировать аудиторию и попасть в общие проекты',
      items: [
        'Всё из «Старт»',
        'Попадание в подборки',
        'Приоритетное размещение',
        'Внутреннее продвижение',
        'Контент платформы',
        'Упаковка автора',
      ],
      price: '30 000 ₽',
      priceCaption: 'единоразово',
      ctaLabel: 'Хочу расти',
      ctaTextColor: '#F4F4F4',
    },
  },
  {
    id: 'pro',
    numeral: 'III',
    title: 'Профи',
    markerTagline: 'Выход вовне',
    tagline: 'Выход за пределы платформы',
    numeralColor: 'text-[#FF3DAE]',
    circleSize: 96,
    circleClassName: 'border-2 border-[#FF66C4] bg-[#1B1D22]',
    showStar: false,
    panelThemeColor: '#FF3DAE',
    levelHeading: 'Уровень III',
    panelBadgeTextureSrc: '/images/original-plus/author-level-badge-3.png',
    panelBadgeGlow: '0 0 124px 0 #FF66C499',
    panel: {
      description:
        'Для авторов, готовых к внешнему присутствию: печатная версия, медиа, фестивали и офлайн-форматы',
      items: [
        'Всё из «Рост»',
        'Печатная версия / POD',
        'Офлайн-дистрибуция',
        'Участие в фестивалях',
        'Публикации в медиа',
        'Интервью, подкасты',
        'Спецпроекты Molwe',
      ],
      price: '50 000 ₽',
      priceCaption: 'за 6 месяцев',
      ctaLabel: 'Выйти в проекты',
      ctaTextColor: '#F4F4F4',
    },
  },
  {
    id: 'production',
    numeral: 'IV',
    title: 'Продюсирование',
    markerTagline: 'Развитие IP',
    tagline: 'Развитие IP',
    numeralColor: 'text-[#A8EA3A]',
    circleSize: 116,
    circleClassName: 'border-2 border-[#A9F84A] bg-[#1B1D22]',
    showStar: true,
    panelThemeColor: '#A8EA3A',
    levelHeading: 'Уровень IV',
    panelBadgeTextureSrc: '/images/original-plus/author-level-badge-4.png',
    panelBadgeGlow: '0 0 124px 0 #A9F84A99',
    panel: {
      description:
        'Для авторов и проектов с потенциалом серии, вселенной, франшизы или кроссформатного продукта',
      items: [
        'Всё из «Профи»',
        'Персональный продюсер',
        'Развитие вселенной',
        'Сценарная адаптация',
        'Гранты и программы',
        'Мерч, AR, спецформаты',
        'Партнёрские проекты',
        'Упаковка под крупные издательства',
      ],
      price: 'от 150 000 ₽',
      priceCaption: 'обсуждается индивидуально',
      ctaLabel: 'Обсудить проект',
      ctaTextColor: '#181818',
    },
  },
] as const;

export type AuthorLevel = (typeof authorLevels)[number];
export type AuthorLevelId = AuthorLevel['id'];
